<template>
	<div class="row">
		<div class="col-12 selector">
			<div class="form-check">
				<input class="form-check-input" type="checkbox" :checked="internet"
					id="serviceInternet" @input="$emit('update:internet', $event.target.checked)">
				<label class="form-check-label" for="serviceInternet">
					Интернет
				</label>
			</div>
			<div class="form-check select-next">
				<input class="form-check-input" type="checkbox" :checked="phone"
					id="servicePhone" @input="$emit('update:phone', $event.target.checked)">
				<label class="form-check-label" for="servicePhone">
					Телефон
				</label>
			</div>
			<div class="form-check select-next">
				<input class="form-check-input" type="checkbox" :checked="tv"
					id="serviceTv" @input="$emit('update:tv', $event.target.checked)">
				<label class="form-check-label" for="serviceTv">
					Телевидение
				</label>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "Selector",
	props: {
		internet: Boolean,
		phone: Boolean,
		tv: Boolean
	}
}
</script>
